import { render, staticRenderFns } from "./TDraftEdit.vue?vue&type=template&id=647498cc&"
import script from "./TDraftEdit.vue?vue&type=script&lang=js&"
export * from "./TDraftEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('647498cc')) {
      api.createRecord('647498cc', component.options)
    } else {
      api.reload('647498cc', component.options)
    }
    module.hot.accept("./TDraftEdit.vue?vue&type=template&id=647498cc&", function () {
      api.rerender('647498cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/services/payments/TDraftEdit.vue"
export default component.exports